import React from "react";
import { Formik, Form, Field } from "formik";
import { Box, Button, Typography } from "@material-ui/core";
import intl from "react-intl-universal";
import { useMutate } from "restful-react";

import { IMatch, submitMatch } from "apis";
import { TextField } from "components/TextField";
import { useSnackbar } from "notistack";

import { FIELD_HOME_TEAM_SCORE, FIELD_AWAY_TEAM_SCORE } from "./constants";

interface MatchResultFormProps {
  scoresFromInput: number;
  match: IMatch;
}

export const MatchResultForm = ({
  scoresFromInput,
  match,
}: MatchResultFormProps) => {
  const { mutate } = useMutate({
    verb: "POST",
    path: submitMatch(),
  });
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    [FIELD_HOME_TEAM_SCORE]:
      match.homeScore < 0 ? "" : match.homeScore.toString(),
    [FIELD_AWAY_TEAM_SCORE]:
      match.awayScore < 0 ? "" : match.awayScore.toString(),
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        const input: IMatch = {
          ...match,
          homeScore: parseInt(values[FIELD_HOME_TEAM_SCORE]),
          awayScore: parseInt(values[FIELD_AWAY_TEAM_SCORE]),
        };
        mutate(input).then((response) => {
          setSubmitting(false);
          if (response.errCode > 0) {
            enqueueSnackbar(response.errMessage, {
              variant: "error",
            });
            return;
          }
          enqueueSnackbar(intl.get("MATCH_RESULT_SUBMIT_SUCC"), {
            variant: "success",
          });
        });
        return;
      }}
    >
      {() => {
        return (
          <Form>
            <Typography>{`${intl.get("STAT_SCORES_FROM_INPUT_LIST", {
              scores: scoresFromInput,
            })}`}</Typography>
            <Box mt={2} />
            <Field
              component={TextField}
              name={FIELD_HOME_TEAM_SCORE}
              label={intl.get("STAT_HOME_SCORES")}
              type="number"
            />
            <Field
              component={TextField}
              name={FIELD_AWAY_TEAM_SCORE}
              label={intl.get("STAT_AWAY_SCORES")}
              type="number"
            />
            <Box mt={2} />
            <Button variant="contained" color="secondary" type="submit">
              {`${intl.get("STAT_FORM_SUBMIT_MATCH_RESULT")}`}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
